module.exports = {
    script: {
        created: false,
        loaded: false
    }
}


// WEBPACK FOOTER //
// ./resources/js/components/pages/cv/tools-components/GoogleMapConfig.js